if (!customElements.get('cart-notification-modal')) {
    customElements.define(
        'cart-notification-modal',
        class CartNotificationModal extends HTMLElement {
            constructor() {
                super();
            }

            connectedCallback() {
                this.isOpen = false;
                this.productContainer = document.getElementById('cart-notification-product');
                this.closeButton = document.getElementById('cart-notification-modal__close');
                this.cartButton = document.getElementById('cart-notification-button');
                this.ajaxCart = document.querySelector('ajax-cart');

                this.onBodyClickHandler = this.onBodyClick.bind(this);
                this.onKeyUpHandler = this.onKeyUp.bind(this);
                this.onTransitionEndHandler = this.onTransitionEnd.bind(this);

                this.addEventListener('keyup', this.onKeyUpHandler);
            }

            disconnectedCallback() {
                if (this.cartUpdateUnsubscriber) {
                    this.cartUpdateUnsubscriber();
                }
                this.removeEventListener('keyup', this.onKeyUpHandler);
                this.removeEventListener('transitionend', this.onTransitionEndHandler);
                document.body.removeEventListener('click', this.onBodyClickHandler);
            }

            onKeyUp(event) {
                if (event.code.toUpperCase() === 'ESCAPE') this.close();
            }

            onTransitionEnd(event) {
                if (event.target !== this) return;
                this.isOpen = !this.isOpen;
                this.classList.remove('cart-notification-modal--transitioning');
                if (this.isOpen) {
                    this.classList.add('cart-notification-modal--transitioned');
                    trapFocus(this, this.querySelector('[role="dialog"]'));
                    document.body.addEventListener('click', this.onBodyClickHandler);
                    this.setAttribute('open', true);
                    publish(PUB_SUB_EVENTS.glideUpdate, {
                        id: 'cart-notification-complementary'
                    });
                } else {
                    document.body.removeEventListener('click', this.onBodyClickHandler);
                    removeTrapFocus(this);
                    this.removeAttribute('open');
                }
                this.removeEventListener('transitionend', this.onTransitionEndHandler);
            }

            onBodyClick(event) {
                const target = event.target;
                if (target === this) {
                    this.close();
                }
            }

            open() {
                if (this.isOpen) return;
                this.ajaxCart?.close();
                const quickAddModal = document.querySelector('quick-add-modal[open]');
                quickAddModal?.hide(true);
                document.body.classList.add('overflow-hidden');
                this.classList.add('cart-notification-modal--transitioning');
                this.classList.remove('cart-notification-modal--transitioned');
                this.addEventListener('transitionend', this.onTransitionEndHandler);
                trapFocus(this);
            }

            close() {
                if (!this.isOpen) return;
                document.body.classList.toggle('overflow-hidden');
                this.classList.remove('cart-notification-modal--transitioned');
                this.addEventListener('transitionend', this.onTransitionEndHandler);
                removeTrapFocus();
            }
        }
    );
}

if (!customElements.get('cart-notification-modal-close')) {
    customElements.define(
        'cart-notification-modal-close',
        class CartNotificationModalClose extends HTMLElement {
            constructor() {
                super();
            }

            connectedCallback() {
                this.setAttribute('tabindex', 0);
                this.setAttribute('role', 'button');
                this.handleKeyUp = this.onKeyUp.bind(this);
                this.handleClick = this.onClick.bind(this, false);

                this.addEventListener('keyup', this.handleKeyUp);
                this.addEventListener('click', this.handleClick);
            }

            disconnectedCallback() {
                this.removeEventListener('keyup', this.handleKeyUp);
                this.removeEventListener('click', this.handleClick);
            }

            onClick() {
                this.closest('cart-notification-modal')?.close();
            }

            onKeyUp(event) {
                event?.code === 'Enter' && this.closest('cart-notification-modal')?.close();
            }
        }
    );
}
